import { createFileRoute } from '@tanstack/react-router';

import { ReadAlongPage } from '@/components/start/read-along/read-along-page';

/** `?note=<id>` opens the document at that note — see `useLoadAudioFromSlug`. */
type ReadAlongSearch = { note?: string };

export const Route = createFileRoute(
  '/app/_authenticated/_dashboard/readalong/$audioIdOrSlug',
)({
  component: Page,
  validateSearch: (search: Record<string, unknown>): ReadAlongSearch => ({
    note: typeof search.note === 'string' ? search.note : undefined,
  }),
});

function Page() {
  const { audioIdOrSlug } = Route.useParams();
  const { note } = Route.useSearch();
  return <ReadAlongPage slug={audioIdOrSlug} noteId={note} />;
}
